import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplaintService } from 'src/app/_service/complaint.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { LeadsService } from '../../_service/leads.service';
import { FeedbackService } from '../../_service/feedback.service';
declare var $: any;

@Component({
  selector: 'app-user-complaints',
  templateUrl: './user-complaints.component.html',
  styleUrls: ['./user-complaints.component.css']
})
export class UserComplaintsComponent implements OnInit {


  complaintForm: FormGroup;userInformation: FormGroup;complaintList: any = []; submitted: boolean = false; loading: boolean = false; myrole: string; loaded: boolean = false; circle = ''; currentUserId: any; status = ''; booleanValue: any = false; IpdId: any = '';bdComplaintList: any = []; 
  doctorComplaintList: any = []; hInfrastructureComplaintList: any = []; hStaffComplaintList: any = []; admissionComplaintList: any = []; dischargeComplaintList: any = []; otherComplaintList: any = [];
  bd_action_time:any;admission_action_time:any;discharge_action_time:any;doctor_action_time:any;hospital_infrastructure_action_time:any;hospital_staff_action_time:any;others_action_time:any;
  hospital_infrastructure_comp_doc:string="";s3url = '';

  constructor(private formBuilder: FormBuilder, private sharedapi: SharedService, private complaintapi: ComplaintService, private activatedRoute: ActivatedRoute, private router: Router,private feedbackapi:FeedbackService,) {
    
    this.userInformation = this.formBuilder.group({
      'pname': [null],
      'treatment': [null],
      'docname': [null],
      'hospitalname': [null],
      'bd_name': [null],
      'description' : [null],
      'complaint_description': [null]
    });

    this.complaintForm = this.formBuilder.group({
      'ipd_id': [null],
      'bd_description': [null],
      'bd_comp_status': [null],
      'doctor_description': [null],
      'doctor_comp_status': [null],
      'hospital_infrastructure_description': [null],
      'hospital_infrastructure_comp_status': [null],
      'hospital_staff_description': [null],
      'hospital_staff_comp_status': [null],
      'admission_description': [null],
      'admission_comp_status': [null],
      'discharge_description': [null],
      'discharge_comp_status': [null],
      'others_description': [null],
      'others_comp_status': [null],
      'final_description': [null],
      'final_status': [null],
      'hospital_infrastructure_com_doc': [null]
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['ipd_id'] && !params['complaint_id']) {
        this.IpdId = params['ipd_id'];
        this.complaintForm.patchValue({
          'ipd_id': this.IpdId
        })
      }
    });
    this.patchPatientData();
    this.loadComplaintList();
    
  }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.s3url = localStorage.getItem('s3url');
    this.currentUserId = localStorage.getItem('loginuserId');
  }

  async patchPatientData() {
    await this.complaintapi.viewIpdDetails(this.IpdId).subscribe((response: any) => {
      if (response.status) {
        this.userInformation.patchValue({
          'pname': response.data.patient,
          'treatment': response.data.treatment_name,
          'docname': response.data.doctor_name,
          'hospitalname': response.data.hospital_name,
          'bd_name': response.data.bd_name,
          'description': response.data.description
        })
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  get f1() { return this.userInformation.controls; }


  async loadComplaintList() {
    let ipdId = {
      "ipd_id": this.IpdId,
    }
    await this.complaintapi.getUserComplaint(ipdId).subscribe((response: any) => {
      if (response.status) {
        this.bdComplaintList = response.data.bd_option_name;
        this.doctorComplaintList = response.data.doctor_option_name;
        this.hInfrastructureComplaintList = response.data.hospital_infrastructure_option_name;
        this.hStaffComplaintList = response.data.hospital_staff_option_name;
        this.admissionComplaintList = response.data.admission_option_name;
        this.dischargeComplaintList = response.data.discharge_option_name;
        this.otherComplaintList = response.data.others_option_name;
        this.admission_action_time = response.data.admission_action_time,
        this.bd_action_time = response.data.bd_action_time,
        this.discharge_action_time = response.data.discharge_action_time,
        this.doctor_action_time = response.data.doctor_action_time,
        this.hospital_infrastructure_action_time = response.data.hospital_infrastructure_action_time,
        this.hospital_staff_action_time = response.data.hospital_staff_action_time,
        this.others_action_time = response.data.others_action_time,
        this.hospital_infrastructure_comp_doc = response.data.hospital_infrastructure_comp_doc;
        this.complaintForm.patchValue({
          'bd_description': response.data.bd_description,
          'bd_comp_status': response.data.bd_comp_status,
          'doctor_description': response.data.doctor_description,
          'doctor_comp_status': response.data.doctor_comp_status,
          'hospital_infrastructure_description': response.data.hospital_infrastructure_description,
          'hospital_infrastructure_comp_status': response.data.hospital_infrastructure_comp_status,
          'hospital_staff_description': response.data.hospital_staff_description,
          'hospital_staff_comp_status': response.data.hospital_staff_comp_status,
          'admission_description': response.data.admission_description,
          'admission_comp_status': response.data.admission_comp_status,
          'discharge_description': response.data.discharge_description,
          'discharge_comp_status': response.data.discharge_comp_status,
          'others_description': response.data.others_description,
          'others_comp_status': response.data.others_comp_status,
          'final_description': response.data.final_description,
          'final_status': response.data.final_status,
        });
        this.userInformation.patchValue({
          'complaint_description': response.data.complaint_description,
        });


      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  async addComplaintAction() {
    this.submitted = true;
    this.loading = true;
    if (this.complaintForm.invalid) {
      this.loading = false;
      return;
    }
    // console.log(this.complaintForm.value);
    // for add complaint Action//

    this.complaintapi.addComplaintAction(this.complaintForm.value)
      .subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.sharedapi.presentToast(data.msg);
          this.router.navigateByUrl('/complaints');
        }
        else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });

  }


  selectDocument(event)
  {
    const file = (event.target as HTMLInputElement).files[0];
    this.complaintForm.patchValue({
      hospital_infrastructure_com_doc: file
    });
  }

}
